import { ErrorBoundary } from 'react-error-boundary';
import { useCallback } from 'react';
import { sentry } from '~features/logging';
import { Fallback } from './fallback';
import type { GenericErrorBoundaryProps } from './types';

export const GenericErrorBoundary = ({
  children,
  hideResetButton,
  onError,
  ...props
}: GenericErrorBoundaryProps) => {
  const handleError = useCallback(
    (error: Error, info: React.ErrorInfo) => {
      // eslint-disable-next-line no-console
      console.error(error);
      onError?.(error, info);
      sentry.captureException(error, info);
    },
    [onError],
  );

  return (
    <ErrorBoundary
      fallbackRender={(fallbackProps) => (
        <Fallback hideResetButton={hideResetButton} {...fallbackProps} />
      )}
      onError={handleError}
      {...props}
    >
      {children}
    </ErrorBoundary>
  );
};
